var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99885 0C8.4426 0 8.85197 0.234375 9.07697 0.61875L15.827 12.1187C16.0551 12.5062 16.0551 12.9844 15.8332 13.3719C15.6113 13.7594 15.1957 14 14.7488 14H1.24885C0.801972 14 0.386347 13.7594 0.164472 13.3719C-0.0574034 12.9844 -0.0542784 12.5031 0.170722 12.1187L6.92072 0.61875C7.14572 0.234375 7.5551 0 7.99885 0ZM7.99885 4C7.58322 4 7.24885 4.33437 7.24885 4.75V8.25C7.24885 8.66562 7.58322 9 7.99885 9C8.41447 9 8.74885 8.66562 8.74885 8.25V4.75C8.74885 4.33437 8.41447 4 7.99885 4ZM8.99885 11C8.99885 10.7348 8.89349 10.4804 8.70595 10.2929C8.51842 10.1054 8.26406 10 7.99885 10C7.73363 10 7.47928 10.1054 7.29174 10.2929C7.1042 10.4804 6.99885 10.7348 6.99885 11C6.99885 11.2652 7.1042 11.5196 7.29174 11.7071C7.47928 11.8946 7.73363 12 7.99885 12C8.26406 12 8.51842 11.8946 8.70595 11.7071C8.89349 11.5196 8.99885 11.2652 8.99885 11Z",
    fill: "#FFD931"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.aae82f2be3528a5a142a3a3ff817270a.svg";
export { ForwardRef as ReactComponent };